import React from "react";
import { Container } from "react-bootstrap";
import ActiveSubscribeForm from "components/active-subscribe-form/new-active-subscribe-form.js";

import { subscribe, subscribeInput } from "./style.mod.scss";

const NewsletterNewLayout = ({ data }) => {

  return (
    <div className={subscribe} style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
      <Container>
        <div className={subscribeInput}>
          <ActiveSubscribeForm data={data}/>
        </div>
      </Container>
    </div>
  );
};

export default NewsletterNewLayout;